import { Record } from 'immutable'
import { CommissionSplit, ICommissionSplit } from './CommissionSplit'
import { IRentalRate, RentalRate } from './RentalRate'

export enum LeaseType {
  NotAvailable = 'NotAvailable',
  FullService = 'FullService',
  NNN = 'NNN',
  ModifiedGross = 'ModifiedGross',
  ModifiedNet = 'ModifiedNet',
  IndustrialGross = 'IndustrialGross',
  Other = 'Other',
}

export interface IListingLeaseData {
  readonly buildToSuit: boolean
  readonly commissionSplit: ICommissionSplit
  readonly dateAvailable?: number
  readonly leaseTermInMonths: number
  readonly leaseType: LeaseType
  readonly rentalRate: IRentalRate
  readonly sublease: boolean
}

const ListingLeaseDataRecord = Record({
  buildToSuit: false,
  commissionSplit: new CommissionSplit(),
  dateAvailable: undefined,
  leaseTermInMonths: 0,
  leaseType: LeaseType.NotAvailable,
  rentalRate: new RentalRate(),
  sublease: false,
})

export class ListingLeaseData extends ListingLeaseDataRecord
  implements IListingLeaseData {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new ListingLeaseData()
    }

    const { commissionSplit, rentalRate, ...rest } = initialState

    return new ListingLeaseData({
      commissionSplit: CommissionSplit.fromJS(commissionSplit),
      rentalRate: RentalRate.fromJS(rentalRate),
      ...rest,
    })
  }

  public readonly buildToSuit: boolean
  public readonly commissionSplit: CommissionSplit
  public readonly dateAvailable?: number
  public readonly leaseTermInMonths: number
  public readonly leaseType: LeaseType
  public readonly rentalRate: RentalRate
  public readonly sublease: boolean

  constructor(props?: Partial<ListingLeaseData>) {
    props ? super(props) : super()
  }
}
